/* Homepage showcase hero: typed title + a deck of product windows on a
   tinted stage. Windows sit on top of each other (the next ones peek above
   the front one); on a switch the front window slides down off the stage and
   the rest step forward. Tabs auto-advance on a timer with a progress line
   and the active job is typed into the stage title. Pauses on hover, focus,
   hidden tab and off-screen; no auto-advance, typing or slide under
   prefers-reduced-motion. Windows behind are aria-hidden + inert. */
(function () {
  function init(root) {
    if (!root.offsetParent) return; /* hidden (e.g. disabled in the editor): no timer, no typing */
    /* load the renders behind the front card now (they ship loading=lazy) */
    [].forEach.call(root.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
    var tabs = [].slice.call(root.querySelectorAll('[data-hs-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-hs-panel]'));
    var stage = root.querySelector('[data-hs-stage]');
    var title = root.querySelector('[data-hs-title]');
    if (tabs.length < 2 || panels.length !== tabs.length) return;
    var n = tabs.length;
    var interval = parseInt(root.getAttribute('data-hs-interval'), 10) || 6000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var current = 0, elapsed = 0, last = null, typeTimer = null, leaveTimer = null;
    var hovered = false, focused = false, visible = true;

    function typeInto(text) {
      if (!title) return;
      clearTimeout(typeTimer);
      if (reduce.matches) { title.textContent = text; return; }
      title.textContent = '';
      root.classList.add('is-typing');
      var i = 0;
      (function step() {
        title.textContent = text.slice(0, ++i);
        if (i < text.length) typeTimer = setTimeout(step, 28);
        else root.classList.remove('is-typing');
      })();
    }
    function layout() {
      panels.forEach(function (p, k) {
        var depth = (k - current + n) % n;          /* 0 = front window */
        p.setAttribute('data-depth', depth);
        p.setAttribute('aria-hidden', depth ? 'true' : 'false');
        if (depth) p.setAttribute('inert', ''); else p.removeAttribute('inert');
      });
    }
    function show(idx, animate) {
      var prev = current;
      current = (idx + n) % n;
      elapsed = 0;
      tabs.forEach(function (t, k) {
        var on = k === current;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.style.setProperty('--hs-progress', 0);
      });
      layout();
      if (animate && prev !== current && !reduce.matches) {
        root.classList.add('is-live');   /* from now on the front window's contents stagger in */
        /* the old front window drops off the bottom of the stage, then re-enters the
           back of the deck: jump (no transition) to the arriving state, then ease into its depth */
        var leaving = panels[prev];
        clearTimeout(leaveTimer);
        panels.forEach(function (p) { p.classList.remove('is-leaving', 'is-arriving', 'no-transition'); });
        leaving.classList.add('is-leaving');
        leaveTimer = setTimeout(function () {
          leaving.classList.add('no-transition', 'is-arriving');
          leaving.classList.remove('is-leaving');
          requestAnimationFrame(function () { requestAnimationFrame(function () {
            leaving.classList.remove('no-transition', 'is-arriving');
          }); });
        }, 660);
      }
      if (stage) {
        var tint = panels[current].getAttribute('data-tint');
        if (tint) stage.style.setProperty('--hs-tint', tint);
      }
      if (animate) typeInto(panels[current].getAttribute('data-title') || '');
    }
    function paused() { return hovered || focused || !visible || document.hidden || reduce.matches; }
    function tick(ts) {
      if (last !== null && !paused()) {
        elapsed += ts - last;
        if (elapsed >= interval) show(current + 1, true);
        tabs[current].style.setProperty('--hs-progress', Math.min(1, elapsed / interval));
      }
      last = ts;
      requestAnimationFrame(tick);
    }

    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { if (k !== current) show(k, true); });
      t.addEventListener('keydown', function (e) {
        var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        show(current + d, true);
        tabs[current].focus();
      });
    });
    root.addEventListener('mouseenter', function () { hovered = true; });
    root.addEventListener('mouseleave', function () { hovered = false; });
    root.addEventListener('focusin', function () { focused = true; });
    root.addEventListener('focusout', function () {
      setTimeout(function () { focused = root.contains(document.activeElement) && document.activeElement !== document.body; }, 0);
    });
    if (typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0.2 }).observe(root);
    }

    show(0, false);   /* first paint keeps the server-rendered title, no typing */
    requestAnimationFrame(tick);
  }
  var roots = document.querySelectorAll('[data-hs-showcase]');
  for (var i = 0; i < roots.length; i++) init(roots[i]);
})();
